import { sendNcFileToMachine } from '@reducers/machines';
import { checkEvent } from '@reducers/utils';

import { SEND_STATUS } from '@helpers';
import type { RunSendToMachineParams, SendNcFileResult } from '@components/search/operations/components/StartJobPopup/types';

// Sends the selected NC file's favorite version to the machine, then waits for the machine to confirm selection.
export const runSendToMachine = async ({
  element,
  dispatch,
  machineId,
  productionOperationId,
  setSendingStorage,
  setMessageStorage,
}: RunSendToMachineParams) => {
  setSendingStorage((prev) => ({
    ...prev,
    [element.ncFileId]: SEND_STATUS.Sending,
  }));

  // productionOperationId is required for the connector to link the upcoming machine run (batch) to this job
  // (BUG 5248). Side effect: backend re-links the file as default "Linked", wiping a manual Setup (SF-5215).
  // TODO: refer here back once backend is resolved and wipe this comment
  const result = (await dispatch(
    sendNcFileToMachine({
      $type: 'favoriteVersion',
      machineId,
      ncFileId: element.ncFileId,
      productionOperationId,
    })
  )) as SendNcFileResult;

  if (result.errorMessage || result.errorType) {
    setSendingStorage((prev) => ({
      ...prev,
      [element.ncFileId]: SEND_STATUS.Error,
    }));
    setMessageStorage((prev) => ({
      ...prev,
      [element.ncFileId]: result.errorMessage,
    }));
    return;
  }

  setSendingStorage((prev) => ({
    ...prev,
    [element.ncFileId]: SEND_STATUS.Sent,
  }));
  setMessageStorage((prev) => ({
    ...prev,
    [element.ncFileId]: result.machineFolderName,
  }));

  try {
    await checkEvent('OnUpdatedMachineStatus', {
      timeout: 120000,
      matcher: (data) => data?.machineStatus?.machineId === machineId && data?.machineStatus?.ncFileId === element.ncFileId,
    });

    setSendingStorage((prev) => ({
      ...prev,
      [element.ncFileId]: SEND_STATUS.Finish,
    }));
  } catch (e) {
    setSendingStorage((prev) => ({
      ...prev,
      [element.ncFileId]: SEND_STATUS.Error,
    }));
    setMessageStorage((prev) => ({
      ...prev,
      [element.ncFileId]: 'Timeout error',
    }));
    return;
  }
};
